var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RouterLink',{staticClass:"lb-sidebar-brand",attrs:{"to":"/"}},[_c('img',{staticClass:"lb-sidebar-brand__logo",attrs:{"width":"30","height":"30","src":require('@/assets/images/logo.svg'),"alt":_vm.$t('BAZAAR')}}),_vm._v(" "),_c('strong',{staticClass:"lb-sidebar-brand__title"},[_vm._v("\n    "+_vm._s(_vm.$t('PISHKHAN'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }